import React from 'react';

interface CheckIconProps {
  className?: string;
  width?: number;
  height?: number;
  fill?: string;
}

const CheckIcon: React.FC<CheckIconProps> = ({
  className = '',
  width = 16,
  height = 16,
  fill = '#00974B',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M6.83333 11.5L12.7083 5.625L11.5417 4.45833L6.83333 9.16667L4.45833 6.79167L3.29167 7.95833L6.83333 11.5ZM2.16667 15.5C1.70833 15.5 1.31597 15.3368 0.989583 15.0104C0.663194 14.684 0.5 14.2917 0.5 13.8333V2.16667C0.5 1.70833 0.663194 1.31597 0.989583 0.989583C1.31597 0.663194 1.70833 0.5 2.16667 0.5H13.8333C14.2917 0.5 14.684 0.663194 15.0104 0.989583C15.3368 1.31597 15.5 1.70833 15.5 2.16667V13.8333C15.5 14.2917 15.3368 14.684 15.0104 15.0104C14.684 15.3368 14.2917 15.5 13.8333 15.5H2.16667Z"
        fill={fill}
      />
    </svg>
  );
};

export default CheckIcon;
